import "./Yearly.css"
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import APIURL from "../../common/Config";
import Header from "../header/header";
import Footer from "../footer/footer";



const Ariesyearly = () => {
  const [horoscopeData, setHoroscopeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const inMemoryCacheRef = useRef(new Map());
   const [activeIndex, setActiveIndex] = useState(null);

  // Static metadata for Aries
  const staticMeta = {
    title: "AstroBhagya – Free Aries Yearly Horoscope by Best Astrologer",
    description: "Looking for accurate Aries yearly horoscope predictions 2026? Discover free Aries astrology predictions and annual insights by zodiac sign for a better year ahead.",
    keywords: "Free Aries yearly horoscope predictions 2026, Aries yearly Astrology predictions, Aries annual predictions, Yearly horoscope by Aries zodiac sign",
    author: "Heavenly Expectation Private Limited",
  };

  const toggleAnswer = (index) => {
  setActiveIndex((prev) => (prev === index ? null : index));
};

  const fetchAriesYearly = useCallback(async (retries = 3) => {
    const dateStr = "20260101"; // 2026 data
    const cacheKey = `aries_yearly_${dateStr}`;
    setError(null);
    setLoading(true);

    // 1. CHECK LOCALSTORAGE
    const cachedData = localStorage.getItem(cacheKey);
    if (cachedData) {
      try {
        const parsed = JSON.parse(cachedData);
        setHoroscopeData(parsed);
        setLoading(false);
        return;
      } catch (e) {
        console.error("Failed to parse cached data:", e);
      }
    }

    // 2. CHECK IN-MEMORY CACHE
    if (inMemoryCacheRef.current.has(cacheKey)) {
      setHoroscopeData(inMemoryCacheRef.current.get(cacheKey));
      setLoading(false);
      return;
    }

    const minLoadingTime = new Promise(resolve => setTimeout(resolve, 500));

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
        console.warn('Fetch request timed out after 15 seconds.');
      }, 15000);

      const response = await fetch(
        `${APIURL}/horroscope/getallprediction?type=yearly&startDate=${dateStr}&endDate=${dateStr}&language=english`,
        { signal: controller.signal }
      );

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (Array.isArray(data)) {
        // Find Aries data (id: 29 or sunShine contains "Aries")
        const ariesData = data.find(
          item => item.id === 29 || item.sunShine?.toUpperCase().includes("ARIES")
        );

        if (ariesData) {
          // Cache the data
          inMemoryCacheRef.current.set(cacheKey, ariesData);
          localStorage.setItem(cacheKey, JSON.stringify(ariesData));
          setHoroscopeData(ariesData);
        } else {
          throw new Error("Aries data not found in API response");
        }
      } else {
        throw new Error("Unexpected response format from API");
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        setError('The network request timed out. Please check your internet connection and try again.');
        console.error("Network timeout error:", error);
      } else {
        setError(`Failed to load yearly horoscope: ${error.message}. Please try again.`);
        console.error("Error fetching Aries yearly data:", error);
      }

      if (retries > 0) {
        console.log(`Retrying fetch for Aries Yearly. Retries left: ${retries - 1}`);
        await new Promise(resolve => setTimeout(resolve, 3000));
        return fetchAriesYearly(retries - 1);
      } else {
        // FALLBACK DATA (from your paste #2)
        console.log("All retries exhausted. Using fallback data.");
        const fallbackData = {
          sunShine: "Aries 2026: Your year, as the stars align",
          prediction: `<div class="horoscope">
            <p>Step into 2026, Aries, with renewed self-belief and a clearer sense of direction. This year is about refining your strengths and using your energy wisely. Rather than pushing forward blindly, 2026 encourages you to act with strategy and awareness.</p>
            <h2>Love and Relationships</h2>
            <p>In 2026, relationships take on a more mature and thoughtful tone for Aries. Singles may find themselves drawn to connections that offer emotional stability rather than excitement alone.</p>
            <h2>Career and Finances</h2>
            <p>Career growth in 2026 depends on planning and discipline. Aries professionals may take on greater responsibilities or leadership roles, but success will require patience and sustained effort.</p>
            <h2>Family and Home Life</h2>
            <p>Family life remains supportive in 2026, though you may need to balance responsibilities carefully. You may play an important role in guiding or supporting a family member.</p>
            <h2>Health & Wellness</h2>
            <p>Health in 2026 requires conscious care. Mental stress may arise due to responsibilities, so maintaining emotional balance is essential.</p>
            <h2>Astrological Remedies</h2>
            <ul>
              <li><strong>Wear Red Coral (Moonga):</strong> After consulting an astrologer, wearing Red Coral may help boost confidence and vitality.</li>
              <li><strong>Tuesday Discipline:</strong> Offering prayers or lighting a diya on Tuesdays can strengthen inner strength and focus.</li>
              <li><strong>Saturn Balance Remedy:</strong> Practising charity or helping the needy on Saturdays may reduce delays and obstacles.</li>
            </ul>
          </div>`
        };
        setHoroscopeData(fallbackData);
      }
    } finally {
      await minLoadingTime;
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAriesYearly();
  }, [fetchAriesYearly]);

  // Set meta tags
  useEffect(() => {
    document.title = staticMeta.title;

    const setOrCreateMetaTag = (name, content) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`);
      if (metaTag) {
        metaTag.setAttribute("content", content);
      } else {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("name", name);
        metaTag.setAttribute("content", content);
        document.head.appendChild(metaTag);
      }
    };

    setOrCreateMetaTag("description", staticMeta.description);
    setOrCreateMetaTag("keywords", staticMeta.keywords);
    setOrCreateMetaTag("author", staticMeta.author);
    setOrCreateMetaTag("revisit-after", "7 days");
    setOrCreateMetaTag("distribution", "global");
    setOrCreateMetaTag("rating", "general");

    let charsetMeta = document.querySelector("meta[charset]");
    if (!charsetMeta) {
      charsetMeta = document.createElement("meta");
      charsetMeta.setAttribute("charset", "UTF-8");
      document.head.prepend(charsetMeta);
    }
  }, []);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner" />
        <p>Loading Aries 2026 Horoscope...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>{error}</p>
        <button className="retry-button" onClick={() => fetchAriesYearly()}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div>
        <section id="Make">
          <div className="year-container">
            <h4 className="mt-3 mb-3 text-center font-weight-bold">
              {horoscopeData?.sunShine || "Aries 2026: Your year, as the stars align"}
            </h4>
            <div className="icons-wrapper text-center mb-4">
              <img
                src={require("../../assets/Ariesss.webp")}
                alt="Aries"
                className="horoscope-icon mx-2"
              />
            </div>

            {horoscopeData?.prediction && (
              <main>
                <div
                  dangerouslySetInnerHTML={{
                    __html: horoscopeData.prediction
                  }}
                />
              </main>
            )}

            <div className="btn-wrapper">
              <Link to="/yearly-horoscope/taurus" className="btn btn-customs">
                <i className="bi bi-arrow-right"></i> Taurus Horoscope 2026
              </Link>
            </div>
          </div>
        </section>


        {/* FAQ SECTION - Exact copy from DailyHoroscope */}
        <div className="faq-section">
          <div className="container-item">
            <h3>Frequently Asked Questions (FAQs) – Aries Yearly Horoscope</h3>
            <div className="fitem">
              {[
                {
                  question: "1. What are the core personality traits of Aries?",
                  answer:
                    "Aries natives are known for their boldness, enthusiasm, and dynamic leadership qualities. Ruled by Mars, they embody a pioneering spirit, confidently pursuing new ventures and inspiring others along the way.",
                },
                {
                  question: "2. What can Aries expect in love and relationships in 2026?",
                  answer:
                    "In 2026, astrological insights indicate a year of growth in love for Aries. Prioritising patience, open communication, and emotional depth can lead to meaningful connections, whether for those deepening existing relationships or meeting someone new.",
                },
                {
                  question: "3. What does 2026 look like for Aries' career and professional growth?",
                  answer:
                    "This year holds promising opportunities for Aries in career development. A proactive mindset, combined with their natural ambition, could open doors to advancements, new roles, or rewarding projects that align with long-term aspirations.",
                },
                {
                  question: "4. What health advice should Aries keep in mind for 2026?",
                  answer:
                    "Astrological guidance for Aries suggests paying attention to physical and mental wellness. Balancing energy through regular exercise, stress management, and periods of rest will be key to maintaining optimal health in 2026.",
                },
                {
                  question: "5. Are there key astrological events for Aries to be aware of in 2026?",
                  answer:
                    "Yes, Aries may find certain planetary alignments particularly impactful. Watching for significant transits can offer helpful insight into when to focus on growth, make decisions, or find moments of clarity.",
                },
                {
                  question: "6. How is my yearly horoscope calculated?",
                  answer:
                    "Your yearly horoscope is based on your sun sign and major planetary transits (Jupiter, Saturn, Rahu-Ketu) throughout the year.",
                },
                {
                  question: "7. When should I follow yearly horoscope remedies?",
                  answer:
                    "Follow remedies during key planetary transits mentioned in your yearly predictions for best results.",
                },
                {
                  question: "8. Can I read yearly horoscope for moon sign?",
                  answer:
                    "Yearly horoscopes work best with sun sign. Moon sign readings require personalized analysis from an expert astrologer.",
                },
                {
                  question: "9. How do yearly horoscopes help decision-making?",
                  answer:
                    "They highlight favorable periods for major decisions in career, relationships, and investments throughout the year.",
                },
                {
                  question: "10. Where can I get personalized yearly horoscope?",
                  answer:
                    "Consult AstroBhagya's expert astrologers for your complete birth chart analysis and personalized predictions.",
                },
              ].map((item, index) => (
                <div className="faq-item" key={index}>
                  <div
                    className={`faq-question ${
                      activeIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleAnswer(index)}
                  >
                    {item.question}
                  </div>
                  <div
                    className={`faq-answer ${
                      activeIndex === index ? "show" : ""
                    }`}
                  >
                    {item.answer}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  );
};

export default Ariesyearly;